module.exports = __webpack_public_path__ + "img/b01.2674943c.png";